import { SET_ORDER } from "../actions/order_actions";

export default function (state = null, action) {
  switch (action.type) {
    case SET_ORDER: {
      return action.order;
    }
    default:
      return state;
  }
}
